var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"min-height-screen h-full",attrs:{"elevation":"0"}},[_c('div',{staticClass:"d-flex justify-center align-center w-full h-full"},[_c('loader')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }